// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__20UTz","footer":"ModalError_footer__xggiy"};